var TabLinksModule = /** @class */ (function () {
    function TabLinksModule() {
    }
    return TabLinksModule;
}());
export { TabLinksModule };
